module.exports = __webpack_public_path__ + "static/media/arrow-left.d52836fb.svg";